// extracted by mini-css-extract-plugin
module.exports = {"container":"activity_container__3j9cF","list":"activity_list__1e9ym"};